<template>
  <div>
    <Card
      :title="$t('common.Condition')"
    >
      <CardSection>
        <BaseNodeProperties
          :node="node"
          :readonly="readonly"
        />
      </CardSection>
    </Card>
    <Card
      :title="$t('common.Filters')"
      :actions="[
        {
          label: $t('common.Add Filter'),
          onAction: addFilter,
          disabled: readonly
        }
      ]"
    >
      <FilterEditor
        v-for="(filter, index) in node.filters"
        :key="index"
        :doc="doc"
        :data="filter"
        :index="index"
        :readonly="readonly"
        @remove="removeFilterAt(index)"
      />
      <CardSection v-if="!node.filters.length">
        {{$t('common.No filters')}}
      </CardSection>
    </Card>
  </div>
</template>

<script>
import mixin from './propertiesMixin'
import FilterEditor from '../FilterEditor'

export default {
  mixins: [mixin],
  components: {
    FilterEditor
  },
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  methods: {
    addFilter() {
      this.node.filters.push({
        key: 'PAGE_URL_CONTAINS',
        operator: null,
        value: null
      })
    },
    removeFilterAt(index) {
      this.node.filters.splice(index, 1)
    }
  }
}
</script>
